import React, { useMemo } from 'react';

import { CheckMatchingType } from '@/modules/employer/components/Lockbox/lockbox.types';
import { SuccessMessage, WarningMessage } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';

interface Props {
  matchingType?: CheckMatchingType;
}

const CheckMatchingMessage: React.FC<Props> = ({ matchingType }) => {
  const message = useMemo(() => {
    switch (matchingType) {
    case CheckMatchingType.FULL_MATCH: {
      return <SuccessMessage title="All data matched" />;
    }
    case CheckMatchingType.AMOUNT_NOT_MATCHED: {
      return <WarningMessage title="Amount doesn't match" />;
    }
    default: {
      return null;
    }
    }
  }, [matchingType]);

  return message;
};

export default CheckMatchingMessage;
